module.exports = __webpack_public_path__ + "static/media/icon-left.7c2f484a.svg";